import * as Yup from 'yup';

export default (yup: typeof Yup) => ({
  retentionPeriod: yup.number()
    .min(25, 'Min value: 25. Only the customer can lower this value.')
    .required('Min value: 25. Only the customer can lower this value.'),
});
